<div class="modal-header shadow-sm">
  <h6 class="modal-title mb-0">{{ title }}</h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body scrollbar-primary thin">
  <!--
  <div class="alert alert-warning py-2 small" role="alert">
    @if (isEdit) {
      Changing status to Available makes this theme selectable by organizations. Only do that once
        the face is in a released watch app build.
    } @else {
      Saving adds a name to the catalog and stores the brief for the watch team. The face itself
        still has to ship in a watch app release before any organization can use it.
    }
  </div>
  -->

  <form [formGroup]="themeForm" autocomplete="off">
    <div class="md-form mb-2">
      <label for="name" class="form-label">Theme Name <span class="text-danger">*</span></label>
      <app-input
        [name]="'name'"
        [type]="'text'"
        [control]="themeForm.controls['name']"
        [submitted]="submitted"
        [required]="true"
        [placeholder]="'e.g. Acme Clinical'"
        [class]="nameError ? 'form-control app-input is-invalid' : 'form-control app-input'"
      ></app-input>
    </div>

    <div class="md-form mb-2">
      <label for="uniqueKey" class="form-label">Unique Key</label>
      <app-input
        [name]="'uniqueKey'"
        [type]="'text'"
        [control]="themeForm.controls['uniqueKey']"
        [readonly]="true"
        [placeholder]="'e.g. nexion202609101413'"
      ></app-input>
      <!--
      <div class="fs-1 d-flex align-items-center gap-1">
        <i-bs
          name="info-circle"
          height="0.75rem"
          width="0.75rem">
        </i-bs>

        <span class="form-text">
          @if (isEdit) {
            Assigned when the theme was added. It does not change if the name is edited.
          } @else {
            Generated from the theme name and the current date and time. Read-only.
          }
        </span>
      </div>
      -->
    </div>

    <div class="md-form mb-2">
      <label class="form-label">
        Design brief
      </label>
      <input
        #briefInput
        type="file"
        class="d-none"
        [accept]="acceptedExtensions"
        (change)="onFileInputChange($event)"
      />

      @if (showDropZone) {
        <div
          class="brief-drop"
          [class.is-dragover]="isDragOver"
          (click)="openFilePicker()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <div class="brief-drop-ic text-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z"/>
            </svg>
          </div>
          <div class="brief-drop-tt">Mockup, PNG, or prompt file</div>
          <div class="brief-drop-ds">
            PNG, JPG, PDF, HTML mockup, or TXT / MD prompt · one file · this is what the watch team builds from
          </div>
        </div>
      } @else {
        <div class="brief-filechip">
          <div class="brief-filechip-ic">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z"/>
            </svg>
          </div>
          <div class="flex-grow-1 min-width-0">
            <div class="brief-filechip-fn">{{ displayBrief?.fileName }}</div>
            @if (briefMeta) {
              <div class="brief-filechip-fm">{{ briefMeta }}</div>
            }
          </div>
          <div class="brief-filechip-acts">
            @if (isEdit && !briefFile) {
              <button type="button" class="btn btn-link text-secondary p-1" title="View" (click)="openBrief()">
                <i-bs name="eye"></i-bs>
              </button>
              <button type="button" class="btn btn-link text-secondary p-1" title="Replace" (click)="openFilePicker()">
                <i-bs name="arrow-left-right"></i-bs>
              </button>
            } @else {
              <button type="button" class="btn btn-link text-secondary p-1" title="View" (click)="openBrief()">
                <i-bs name="eye"></i-bs>
              </button>
              <button type="button" class="btn btn-link text-danger p-1" title="Remove" (click)="removeBrief()">
                <i-bs name="x-lg"></i-bs>
              </button>
            }
          </div>
        </div>
      }

      <!--
      <div class="fs-1 d-flex align-items-start gap-1">
        <i-bs name="info-circle" height="0.75rem" width="0.75rem"></i-bs>
        <span class="form-text">
          Optional. Drop a visual mockup or a written prompt — whatever the watch developers need to create this variation.
        </span>
      </div>
      -->
    </div>

    @if (isEdit) {
      <div class="row gx-3 mb-2">
        <div class="col-6">
          <label class="form-label">Status <span class="text-danger">*</span></label>
          <app-select
            [form]="themeForm"
            [control]="themeForm.controls['status']"
            [controlName]="'status'"
            [filter]="false"
            [submitted]="submitted"
            [required]="true"
            [data]="statusOptions"
            [name]="'label'"
            [value]="'value'"
          ></app-select>
        </div>
        <div class="col-6">
          <label class="form-label">Watch App Version</label>
          <app-input
            [name]="'watchAppVersion'"
            [type]="'text'"
            [control]="themeForm.controls['watchAppVersion']"
            [submitted]="submitted"
            [required]="themeForm.value.status === 'Available'"
            [placeholder]="'e.g. v2.4.0'"
          ></app-input>
        </div>
      </div>
    }

    <div class="md-form mb-2">
      <label class="form-label">Description</label>
      <textarea
        class="form-control theme-description"
        rows="4"
        formControlName="description"
        placeholder="Short note for other admins — who requested it, which client, any timing"
      ></textarea>
    </div>

    @if (isEdit) {
      <div class="md-form mb-2">
        <div class="d-flex justify-content-between align-items-center">
          <label class="form-label mb-0" for="isDefault">Default theme</label>
          <div class="form-check form-switch mb-0">
            <input
              class="form-check-input"
              type="checkbox"
              id="isDefault"
              formControlName="isDefault"
            />
          </div>
        </div>
        <!--
        <div class="fs-1 d-flex align-items-start gap-1">
          <i-bs name="info-circle" height="0.75rem" width="0.75rem"></i-bs>
          <span class="form-text">
            @if (isCurrentDefault) {
              Promote another Available theme to default before retiring this one.
            } @else if (!canBeDefault) {
              Only an Available theme with a watch app version can be the default.
            } @else {
              Organizations and watches fall back to this face when a theme is retired or none is assigned.
            }
          </span>
        </div>
        -->
      </div>
    }

    <!--
    @if (!isEdit) {
      <div class="theme-banner theme-banner-info" role="status">
        <i-bs name="clock-fill" width="0.9rem" height="0.9rem"></i-bs>
        <div>
          Saved as <strong>Pending Build</strong> with no watch app version. Set status and version later from Edit,
          after the face has shipped.
        </div>
      </div>
    }
    @if (isEdit && organizationCount > 0) {
      <div class="theme-banner theme-banner-info" role="status">
        <i-bs name="diagram-3-fill" width="0.9rem" height="0.9rem"></i-bs>
        <div>
          {{ organizationCount }} organizations currently use this theme. Setting it to Retired
          immediately reassigns those {{ organizationCount }} to the default theme (Wise Owl). Their
          watches switch on the next check-in / configuration sync.
        </div>
      </div>
    }
    -->
  </form>
</div>
<div class="modal-footer pt-0 d-flex justify-content-between">
  <button type="button" class="btn btn-gray-light" (click)="close()">Cancel</button>
  <button
    type="button"
    class="btn btn-primary d-flex align-items-center"
    [disabled]="loading || !canSave"
    (click)="save()"
  >
    @if (loading) {
      <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
    }
    Save
  </button>
</div>
